var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"hour-overview"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.hours.title)+":")]),_vm._v("\n    "+_vm._s(_vm.shortHours)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }